module.exports = __webpack_public_path__ + "img/ecs_cleaner.34522bc3.png";